<ion-content>
  <ion-list color="light">
    <ion-item lines="none">
      <ion-button
        expand="block"
        color="primary"
        fill="clear"
        class="animate__animated animate__slideInUp animate__fast"
        (click)="logout()"
      >
        Cerrar sesión
        <ion-icon name="log-out-outline" slot="end"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button
      expand="block"
        color="primary"
        fill="clear"
        class="animate__animated animate__slideInUp animate__fast"
      (click)="privacy('terms')">
        Políticas
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button
      expand="block"
        color="danger"
        fill="clear"
        class="animate__animated animate__slideInUp animate__fast"
      (click)="deleteAccount()">
        Eliminar cuenta
      </ion-button>
    </ion-item>
    <ion-item lines="none">
      <ion-button
      expand="block"
        color="primary"
        fill="clear"
        class="animate__animated animate__slideInUp animate__fast"
      >
        Versión {{version}}
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>
